import Vue from 'vue'
import ElementUI from 'element-ui';
import Blob from './excel/Blob';
import Export2Excel from './excel/Export2Excel';
import 'element-ui/lib/theme-chalk/index.css';
/* eslint-disable */
import $ from 'jquery';


import _ from 'lodash';
import md5 from 'js-md5';
import api from './api/index.js';
import common from '@/utils/commonUtils.js';
import port from './api/port.js';
import echarts from 'echarts';
import moment from 'moment';
import filters from './filters'

for(let i in filters){
  Vue.filter(i, filters[i]);
}


Vue.prototype.$md5 = md5;
Vue.prototype.$api = api;
Vue.prototype.$port = port;
Vue.prototype._ = _; //loadsh
Vue.prototype.$echarts = echarts //echarts
Vue.prototype.$moment = moment //moment
Vue.prototype.common = common;
Vue.prototype.$file_url =  "https://ydoss.wondpay.cn/";  //oss地址 

import '@/assets/styles/index.scss';
import '@/permission';

import './assets/iconfont/iconfont.css';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
